import { PUBLIC_ENV } from '@/constants/config'
import { ImageAsset } from '@/types/common'

const PRESIGNED_UPLOAD_TIMEOUT_MS = 30_000

export function getShortOrderUploadFileUrl(userId: string, buyOrderId: string, fileName: string) {
  // #TODO Use  "IsDevelop" to determin between "dev" and "prod" when we are in production.
  const folder = PUBLIC_ENV
  return `/${folder}/${userId}/buyOrder/paymentProof/${buyOrderId}/${fileName}`
}

export function getFileNameFromUrl(url: string) {
  const urlObject = new URL(url)
  const paths = urlObject.pathname.split('/')
  return paths[paths.length - 1]
}

export const generateRandomFileName = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < 10; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}

export const uploadImageToPresigned = async (imageAsset: ImageAsset, fileName: string, uploadUrl: string) => {
  const image = await fetch(imageAsset.uri)
  const imageBlob = await image.blob()

  const contentType = imageAsset.mimeType ? decodeURIComponent(imageAsset.mimeType) : image.headers?.get('Content-Type')
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), PRESIGNED_UPLOAD_TIMEOUT_MS)
  let resp: Response
  try {
    resp = await fetch(uploadUrl, {
      headers: {
        'Content-Type': contentType || 'image/jpeg',
        'Content-Disposition': `attachment; filename="${fileName}"`
      },
      method: 'PUT',
      body: imageBlob,
      signal: controller.signal
    })
  } finally {
    clearTimeout(timeout)
  }

  if (resp.status !== 200) {
    throw new Error(`Image upload failed with status ${resp.status}`)
  } else {
    console.info('Presigned image upload completed', { status: resp.status })
  }
}
